import React from "react";
import IDialog from "./IDialog";
import DialogWindowType from "./DialogWindowType";
import ConfirmationDialog from "./ConfirmationDialog";
import LicenseDialog from "./LicenseDialog";
import ContactFormDialog from "./ContactFormDialog";

function DialogWindow(dialog: IDialog) {
  switch (dialog.type) {
    case DialogWindowType.LICENSE:
      return <LicenseDialog {...dialog} />;

    case DialogWindowType.CONTACTFORM:
      return <ContactFormDialog {...dialog} />
    default:
      return <ConfirmationDialog {...dialog} />;
  }
}

export default DialogWindow;
